import { Box, useTheme } from "@mui/material";
import Label from "@/modules/common/components/ui-kit/label";

interface LeadStatusLabelsProps {
  type?: string;
  isActive: boolean;
}

export default function StatusLabelSection({
  type,
  isActive,
}: LeadStatusLabelsProps) {
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", gap: theme.nawy.spacing.xs, flexWrap: "wrap" }}>
      {type && <Label label={type} variant="secondary" color="blue" />}
      <Label
        label={isActive ? "Active" : "Inactive"}
        variant="secondary"
        color={isActive ? "green" : "red"}
      />
    </Box>
  );
}
